import { ICategory, IResource, IResourceDetails } from '@interfaces/resources';

import { apiUrls } from './urls';
import { get } from './utils';

export const getCategories = () => get<ICategory[]>(apiUrls.dashboard.getCategories);
export const getResource = (id: number) =>
  get<IResource[]>(`${apiUrls.dashboard.getResource}/${id}`);
export const getResourceDetails = (id: number) =>
  get<IResourceDetails>(`${apiUrls.dashboard.getResourceDetails}/${id}`);
